var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { BlockLayoutsProvider } from "./block-layouts-context";
import { DefaultBlockLayoutProvider } from "./default-block-layout-context";
import { DefaultPageLayoutProvider } from "./default-page-layout-context";
import { DefaultSliceLayoutProvider } from "./default-slice-layout-context";
import { PageLayoutsProvider } from "./page-layouts-context";
import { SliceLayoutsProvider } from "./slice-layouts-context";
import { useDefaultBlockLayout } from "../hooks/use-default-block-layout";
import { useDefaultPageLayout } from "../hooks/use-default-page-layout";
import { useDefaultSliceLayout } from "../hooks/use-default-slice-layout";
import { PageLayoutStandard } from "../entities/page-layout-standard";
import { IndicatorLayoutsProvider } from "./indicator-layouts-context";
import { IndicatorGroupLayoutsProvider } from "./indicator-group-layouts-context";
export var IdentityLayout = function (_a) {
  var children = _a.children;
  return React.createElement(React.Fragment, null, children);
};
export var defaultLayoutsContextValue = {
  pageLayouts: {},
  blockLayouts: {},
  sliceLayouts: {},
  defaultBlockLayout: function (children) {
    return React.createElement(React.Fragment, null, children);
  }
};
export var LayoutsProviderDefaultProps = {
  value: defaultLayoutsContextValue
};
export var LayoutsProvider = function (props) {
  var defaultPageLayoutContextValue = useDefaultPageLayout();
  var defaultSliceLayoutContextValue = useDefaultSliceLayout();
  var defaultBlockLayoutContextValue = useDefaultBlockLayout();
  var children = props.children;
  // look for PageLayoutDefault, SliceLayoutDefault as "default" keys in each dictionary. That is, if these are present in the collections, use them automatically
  var defaultPageLayoutFallback = defaultPageLayoutContextValue || props.value.defaultPageLayout || props.value && props.value.pageLayouts && props.value.pageLayouts.PageLayoutDefault || PageLayoutStandard;
  var defaultSliceLayoutFallback = defaultSliceLayoutContextValue || props.value.defaultSliceLayout || props.value && props.value.sliceLayouts && props.value.sliceLayouts.SliceLayoutDefault;
  var defaultBlockLayoutFallback = defaultBlockLayoutContextValue || props.value.defaultBlockLayout || props.value && props.value.blockLayouts && props.value.blockLayouts.BlockLayoutDefault;
  // chaneg these once a sensible default is built
  var defaultIndicatorLayoutFallback = IdentityLayout;
  var defaultIndicatorGroupLayoutFallback = IdentityLayout;
  var value = __assign(__assign(__assign({}, LayoutsProviderDefaultProps.value), {
    defaultPageLayout: defaultPageLayoutFallback,
    defaultSliceLayout: defaultSliceLayoutFallback,
    defaultBlockLayout: defaultBlockLayoutFallback,
    defaultIndicatorLayout: defaultIndicatorLayoutFallback,
    defaultIndicatorGroupLayout: defaultIndicatorGroupLayoutFallback
  }), props.value);
  var pageLayouts = value.pageLayouts,
    sliceLayouts = value.sliceLayouts,
    blockLayouts = value.blockLayouts,
    indicatorLayouts = value.indicatorLayouts,
    indicatorGroupLayouts = value.indicatorGroupLayouts,
    defaultPageLayout = value.defaultPageLayout,
    defaultSliceLayout = value.defaultSliceLayout,
    defaultBlockLayout = value.defaultBlockLayout,
    defaultIndicatorLayout = value.defaultIndicatorLayout,
    defaultIndicatorGroupLayout = value.defaultIndicatorGroupLayout;
  return React.createElement(PageLayoutsProvider, {
    value: pageLayouts
  }, React.createElement(SliceLayoutsProvider, {
    value: sliceLayouts
  }, React.createElement(BlockLayoutsProvider, {
    value: blockLayouts
  }, React.createElement(IndicatorLayoutsProvider, {
    value: indicatorLayouts
  }, React.createElement(IndicatorGroupLayoutsProvider, {
    value: indicatorGroupLayouts
  }, React.createElement(DefaultBlockLayoutProvider, {
    value: defaultBlockLayout
  }, React.createElement(DefaultPageLayoutProvider, {
    value: defaultPageLayout
  }, React.createElement(DefaultSliceLayoutProvider, {
    value: defaultSliceLayout
  }, children))))))));
};
LayoutsProvider.defaultProps = LayoutsProviderDefaultProps;